import {useRouter} from 'next/router';
import {MouseEvent, SyntheticEvent, useCallback} from 'react';
import {openCashCharge} from '../../cashcharge/openCashCharge.function';
import useTypedSelector from '../../common/useTypedSelector';
import {generateRelayRedirectUrl} from '../../domain/relay/redirect/util/generateRelayRedirectUrl';
import {CommonMobileHeaderType} from '../../header/constants';
import {LOG_CLICK_EVENT} from '../../logging/logEvent';
import {useLogin} from '../../user/useLogin.hook';
import {MobileCommonHeader} from '../organisms/MobileCommonHeader/MobileCommonHeader';

interface MobileLayoutCommonHeaderProps {
  headerType: CommonMobileHeaderType;
  headerTitle?: string;
  isKakaotalk: boolean;
  onClickBack: (e: SyntheticEvent) => void;
  onClickHome: (e: SyntheticEvent) => void;
}

export function MobileLayoutCommonHeader({
  headerType,
  headerTitle,
  isKakaotalk,
  onClickBack,
  onClickHome,
}: MobileLayoutCommonHeaderProps) {
  const router = useRouter();

  const {user, isGiftUpdated} = useTypedSelector(state => ({
    user: state.user.user,
    isGiftUpdated: state.todayGift.isUpdated,
  }));

  const {isLogin, doLogin} = useLogin();

  const onClickProfile = useCallback(
    (e: MouseEvent) => {
      function handler() {
        if (!isLogin) {
          doLogin();
          return;
        }
        router.push('/more');
      }
      LOG_CLICK_EVENT('숏컷_더보기_클릭', e, handler);
    },
    [doLogin, isLogin, router]
  );

  const onClickInven = useCallback(
    (e: MouseEvent) => {
      function handler() {
        if (!isLogin) {
          doLogin('/inven/recent');
          return;
        }
        router.push('/inven/recent');
      }
      LOG_CLICK_EVENT('숏컷_보관함_클릭', e, handler);
    },
    [doLogin, isLogin, router]
  );

  const onClickGift = useCallback(
    (e: MouseEvent) => {
      function handler() {
        router.push('/today-gift/0');
      }
      LOG_CLICK_EVENT('숏컷_선물함_클릭', e, handler);
    },
    [router]
  );

  const onClickSearch = useCallback(
    (e: MouseEvent) => {
      function handler() {
        router.push('/search');
      }
      LOG_CLICK_EVENT('숏컷_검색_클릭', e, handler);
    },
    [router]
  );

  const onClickCashCharge = useCallback((e: MouseEvent) => {
    LOG_CLICK_EVENT('캐시충전_클릭', e, () =>
      openCashCharge({
        returnUrl: generateRelayRedirectUrl(window.location.href),
        cashChargeInfo: {
          cash_cvr: '캐시내역',
        },
      })
    );
  }, []);

  return (
    <MobileCommonHeader
      shouldShowUserThumbnail={isLogin}
      userThumbnailUrl={user?.thumbnail}
      onClickProfile={onClickProfile}
      onClickBack={onClickBack}
      onClickLogo={onClickHome}
      onClickInven={onClickInven}
      onClickGift={onClickGift}
      onClickHome={onClickHome}
      onClickSearch={onClickSearch}
      onClickCashCharge={onClickCashCharge}
      headerType={headerType}
      title={headerTitle}
      isGiftUpdated={isGiftUpdated}
      isKakaotalk={isKakaotalk}
    />
  );
}
